import { Route, Switch } from "react-router";
import RenewalsForm from "./RenewalsForm.jsx";
import RenewalsTable from "./RenewalsTable.jsx";
import WriteRoute from "../../../shared/components/WriteRoute";

export default () => (
  <Switch>
    <Route
      exact path="/reminders/renewals"
      component={RenewalsTable}
    />
    <WriteRoute
      exact
      path="/reminders/renewals/addnew"
      component={RenewalsForm}
      redirectTo="/reminders/renewals"
    />
  </Switch>
);
